export const stageCategories = ['ทั้งหมด', 'บนเวที', 'กิจกรรมและเบื้องหลัง', 'สื่อและประชาสัมพันธ์'] as const
export type StageCategory = typeof stageCategories[number]
export type StagePhoto = { id: string; category: Exclude<StageCategory, 'ทั้งหมด'>; caption: string }

// All 42 organizer-supplied photos, including archival posters and screenshots.
// Categories describe visible content, without guessing an event date or edition.
const stage: StagePhoto['category'] = 'บนเวที'
const community: StagePhoto['category'] = 'กิจกรรมและเบื้องหลัง'
const media: StagePhoto['category'] = 'สื่อและประชาสัมพันธ์'
const photos: [string, StagePhoto['category'], string][] = [
  ['0446', stage, 'แสงไฟ ความมั่นใจ และช่วงเวลาบนเวที Miss Wellness World Thailand'],
  ['0410', stage, 'ผู้เข้าร่วมในชุดราตรีบนเวที Miss Wellness World'],
  ['0445', stage, 'รอยยิ้มและช่อดอกไม้ในช่วงประกาศรางวัล'],
  ['0424', community, 'ผู้เข้าร่วมในชุดไทยกับบรรยากาศกิจกรรมวัฒนธรรม'],
  ['0460', stage, 'ค่ำคืนแห่งความทรงจำ ภายใต้แสงไฟบนเวที'],
  ['0409', media, 'บรรยากาศการให้สัมภาษณ์สื่อมวลชนของ Miss Wellness World'],
  ['0411', media, 'ภาพประชาสัมพันธ์ Miss Wellness World จากสื่อของงานที่ผ่านมา'],
  ['0421', media, 'ภาพข่าวประชาสัมพันธ์และบรรยากาศการแถลงข่าว'],
  ['0423', media, 'ภาพเวทีจากสื่อประชาสัมพันธ์ Miss Wellness World'],
  ['0425', media, 'ผู้จัดและแขกร่วมให้สัมภาษณ์ต่อสื่อมวลชน'],
  ['0426', stage, 'ผู้เข้าร่วมและผู้จัดร่วมช่วงเวลาพิเศษบนเวที'],
  ['0427', stage, 'ภาพร่วมกับผู้ได้รับรางวัลบนเวที Miss Wellness World'],
  ['0428', community, 'ช่วงเวลาพักผ่อนร่วมกันท่ามกลางธรรมชาติ'],
  ['0429', community, 'กิจกรรมเรียนรู้และสัมผัสธรรมชาติร่วมกัน'],
  ['0430', community, 'ผู้เข้าร่วมกับบรรยากาศสีเขียวและภูเขา'],
  ['0431', community, 'พลังและรอยยิ้มในกิจกรรมกลางแจ้ง'],
  ['0432', community, 'กิจกรรมสงบใจและดูแลสุขภาวะภายใน'],
  ['0433', stage, 'ผู้เข้าร่วมในชุดไทยบนเวทีกิจกรรมยามค่ำคืน'],
  ['0434', community, 'สีสันของชุดไทยและการทำกิจกรรมร่วมกัน'],
  ['0435', community, 'ภาพรวมผู้เข้าร่วม ทีมงาน และแขกของงาน'],
  ['0436', stage, 'ผู้เข้าร่วมและแขกถ่ายภาพร่วมกันบนเวที'],
  ['0437', community, 'บรรยากาศพบปะผู้เข้าร่วมในงานกิจกรรม'],
  ['0439', stage, 'ช่วงเวลาของผู้สวมมงกุฎบนเวที Miss Wellness World Thailand'],
  ['0440', media, 'โปสเตอร์รับสมัคร Miss Wellness World Thailand 2026 จากสื่อที่ผ่านมา'],
  ['0441', media, 'บทความข่าวและภาพประชาสัมพันธ์ Miss Wellness World Thailand'],
  ['0442', media, 'ผู้จัดและตัวแทนเวทีร่วมให้สัมภาษณ์ในงานแถลงข่าว'],
  ['0443', media, 'สื่อมวลชนร่วมบันทึกภาพการแถลงข่าว'],
  ['0444', media, 'ภาพร่วมกันของตัวแทนเวทีและแขกในงานประชาสัมพันธ์'],
  ['0447', stage, 'ผู้สวมมงกุฎกับช่วงเวลาแห่งความภาคภูมิใจ'],
  ['0448', stage, 'ผู้ได้รับรางวัลร่วมยืนบนเวทีพร้อมช่อดอกไม้'],
  ['0449', stage, 'สีสันของชุดราตรีบนเวที Miss Wellness World Thailand'],
  ['0450', stage, 'ผู้เข้าร่วมทุกคนร่วมช่วงเวลาสำคัญบนเวที'],
  ['0451', media, 'ภาพการประกาศรางวัลจากสื่อของเวที Thailand'],
  ['0452', media, 'บรรยากาศการร่วมรายการในสตูดิโอโทรทัศน์'],
  ['0453', community, 'ภาพหมู่ของผู้เข้าร่วมและทีมงานภายในสถานที่จัดกิจกรรม'],
  ['0459', community, 'รอยยิ้มของผู้เข้าร่วมและตัวแทนเวทีระหว่างกิจกรรม'],
  ['0590', community, 'กิจกรรมปลูกต้นไม้และดูแลพื้นที่สีเขียวร่วมกัน'],
  ['0592', community, 'ตัวแทนเวทีร่วมกิจกรรมกับเครือข่ายพันธมิตร'],
  ['0593', community, 'บรรยากาศการร่วมงานและพบปะเครือข่าย'],
  ['0594', community, 'ภาพร่วมกันของผู้เข้าร่วมในงานกิจกรรมกลางแจ้ง'],
  ['0595', community, 'ช่วงเวลาพบปะและถ่ายภาพร่วมกับผู้ร่วมงาน'],
  ['0596', community, 'ภาพมุมกว้างของผู้คนที่มาร่วมกิจกรรม'],
]
export const stagePhotos: StagePhoto[] = photos.map(([id, category, caption]) => ({ id: `img-${id}`, category, caption }))
export const stageImage = (photo: StagePhoto, size: 240 | 640 | 1600) => `/images/stage/${photo.id}-${size}.webp`
